export const UPDATE = "posts/UPDATE";
export const UPDATE_ONE = "posts/UPDATE_ONE";
export const DESTROY = "posts/DESTROY";
export const APPEND = "posts/APPEND";
export const SET_SELECTED = "posts/SET_SELECTED";
export const EMPTY = "posts/EMPTY";
export const LOADING = "posts/LOADING";
